var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-venue-nearby places-nearby default-panel"},[_c('ViewLayoutModuleHeader',{staticClass:"padded",attrs:{"title":"Places nearby"}},[_c('RouterLink',{attrs:{"to":{
				hash: `#latitude=${_vm.venueModel.getLatitude()}&longitude=${_vm.venueModel.getLongitude()}`,
				name: 'PageMap',
			}}},[_vm._v(" View Map ")])],1),_c('ChalkyVenueList',{attrs:{"venueCollection":_vm.venueCollection,"view":_vm.grid ? 'grid' : 'horizontal'},on:{"venue:select":_vm.Handle_OnSelectVenue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }